export default __webpack_public_path__ + "static/media/telegram-dark.e37735ed.png";